import type { ReactElement } from "react";
import { useState, useCallback } from "react";
import { Card } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import { ClientEntityHierarchyTakeover } from "./ClientEntityHierarchyTakeover";
import { EntitiesByBillingGroupGrid } from "./EntitiesByBillingGroupGrid";
import { entitiesCardContainer } from "./styles_vanilla.css";

export type EntitiesCardNewProps = {
  clientId: string;
  clientName?: string;
  onChangeClientInfo?: () => void;
};

export const EntitiesCardNew = ({
  clientId,
  clientName = "",
  onChangeClientInfo,
}: EntitiesCardNewProps): ReactElement => {
  const isBillingSaveUserGridViewFlagEnabled = useFeatureFlag("billingSaveUserGridView", false);
  const isHierarchyEnabled = useFeatureFlag("billingClientEntityHierarchy", false);
  const [showHierarchy, setShowHierarchy] = useState(false);

  const handleViewHierarchy = useCallback(() => {
    setShowHierarchy(true);
  }, []);

  const handleCloseHierarchy = useCallback(() => {
    setShowHierarchy(false);
  }, []);

  return (
    <>
      <Card className={entitiesCardContainer}>
        <EntitiesByBillingGroupGrid
          clientId={clientId}
          isBillingSaveUserGridViewFlagEnabled={isBillingSaveUserGridViewFlagEnabled}
          onChangeClientInfo={onChangeClientInfo}
          onViewHierarchy={isHierarchyEnabled ? handleViewHierarchy : undefined}
        />
      </Card>
      {isHierarchyEnabled && showHierarchy && (
        <ClientEntityHierarchyTakeover
          clientId={clientId}
          clientName={clientName}
          onExit={handleCloseHierarchy}
        />
      )}
    </>
  );
};
